import React, { useEffect, useState } from "react";
import AECPLogo from "./dashboard/images/AECP_logo.png";
import Deco1 from "./dashboard/images/Deco-right-register2.png";
import Deco2 from "./dashboard/images/Deco-right-register3.png";
import Deco3 from "./dashboard/images/Deco-right-register4.png";
import Deco4 from "./dashboard/images/Deco-right-register5.png";
import Deco5 from "./dashboard/images/Deco-right-register.png";
import { api } from "api";
import { ToastContainer, toast } from "react-toastify"; // Import ToastContainer and toast
import 'react-toastify/dist/ReactToastify.css'; // Import the CSS for Toastify
import { useNavigate } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Button, Navbar } from "reactstrap";



 

export default function CompanyRegisterPage() {
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        companyName: "",
        companyAddress: "",
        gstNumber: "",
      });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
      const onScroll = () => setIsScrolled(window.scrollY > 20);
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post('companyRegistration.php', {
        first_name: form.firstName,
        last_name: form.lastName,
        phone_number: form.mobile,
        email: form.email,
        company_name: form.companyName,
        company_address: form.companyAddress,
        gst_no: form.gstNumber,
      });

      if (response.data.status === 'success') {
        toast.success("Registration submitted successfully!");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      toast.error("An error occurred while submitting the form.");
    }
    setLoading(false);
  };

  const navigate = useNavigate();

  return (
    
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#ffffff] relative overflow-hidden">
      <Navbar
                    className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 py-0  ${
                      isScrolled
                        ? "backdrop-blur-md bg-gray-100 shadow-md text-black"
                        : " bg-gray-100 text-black"
                    } border-0`}
                    style={{ border: "none" }}
                    blurred={true}
                    fullWidth={true}
                    shadow={false}
                  >
                    <div className="container mx-auto flex items-center justify-between ">
                      <img
                        src={require("./dashboard/images/AECP_logo.png")}
                        alt="AECP Logo"
                        style={{ height: "90px", width: "auto", marginRight: "16px", cursor: "pointer" }}
                        onClick={() => navigate("/")}
                      />
                      {/* LOGO left-aligned */}
                      <div className="flex-1 flex items-center">
                        {/* <Typography
                          variant="h5"
                          className={`text-white font-bold tracking-wider ${
                            isScrolled ? "text-black" : "text-white"
                          }`}
                        >
                          LOGO
                        </Typography> */}
                      </div>
                      {/* Hamburger Icon for mobile */}
                      <button
                        className="lg:hidden text-black focus:outline-none"
                        onClick={() => setMobileMenuOpen(true)}
                        aria-label="Open menu"
                      >
                        <Bars3Icon className="w-7 h-7" />
                      </button>
                      {/* Nav links centered (desktop only) */}
                      <div
                        className={`flex-1 hidden lg:flex justify-center gap-8 ${
                          isScrolled ? "text-black" : "text-black"
                        }`}
                      >
                        {[
                          { label: "About Us", to: "/#aboutus" },
                          { label: "Features", to: "/#features" },
                          { label: "Blogs", to: "/#blogs" },
                          { label: "FAQs", to: "/#faqs" },
                          { label: "Contact Us", to: "/#contactus" },
                        ].map((item) => (
                          <a
                            key={item.label}
                            href={item.to}
                            className={`text-black font-medium hover:text-[#E08681] transition whitespace-nowrap`}
                            onClick={e => {
                              e.preventDefault();
                              window.location.href = item.to;
                            }}
                          >
                            {item.label}
                          </a>
                        ))}
                      </div>
                      {/* Login button right-aligned and smaller (desktop only) */}
                      <div className="flex-1 hidden lg:flex justify-end gap-2">
                        <Button
                          className="px-3 py-1.5 rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681]"
                          onClick={() => navigate("/company-register")}
                        >
                          Register
                        </Button>
                        <Button
                          className="px-4 py-1.5 rounded-md font-semibold text-sm shadow-none min-w-0 h-9 bg-[#E08681]"
                          style={{ minWidth: "80px" }}
                          onClick={() => navigate("/login")}
                        >
                          Login
                        </Button>
                      </div>
                    </div>
                    {/* Mobile Menu Drawer */}
                    {mobileMenuOpen && (
                      <div
                        className="fixed inset-0 z-[999] bg-black/40 lg:hidden"
                        onClick={() => setMobileMenuOpen(false)}
                      >
                        <div
                          className="absolute top-0 right-0 w-4/5 max-w-xs h-full bg-pink-100 shadow-lg flex flex-col p-4  gap-6 overflow-y-auto"
                          onClick={(e) => e.stopPropagation()}
                          style={{ minHeight: "100vh" }}
                        >
                          <div className="flex justify-between items-center mb-4">
                          <img
                              src={require("./dashboard/images/AECP_logo.png")}
                              alt="AECP Logo"
                              style={{ height: "90px", width: "auto", marginRight: "16px" }}
                            />
                            <button
                              onClick={() => setMobileMenuOpen(false)}
                              aria-label="Close menu"
                            >
                              <XMarkIcon className="w-7 h-7 text-white" />
                            </button>
                          </div>
                          <nav className="flex flex-col gap-4 items-center">
                            {["About Us", "Features", "Blogs", "FAQs", "Contact Us"].map(
                              (item, idx) => (
                                <a
                                  key={item}
                                  href={`#${item.toLowerCase().replace(/ /g, "")}`}
                                  className="text-white font-medium text-lg py-2 px-2 rounded hover:bg-[#13c9a7]/20 transition"
                                  onClick={() => setMobileMenuOpen(false)}
                                >
                                  {item}
                                </a>
                              )
                            )}
                          </nav>
                          <button className="mt-4 w-full bg-[#E08681] text-white font-semibold rounded-md py-2"
                             onClick={() => {
                              setMobileMenuOpen(false);
                              navigate("/company-register");
                            }}
                          >
                            Register
                          </button>
                          <button className="mt-4 w-full bg-[#E08681] text-white font-semibold rounded-md py-2"
                             onClick={() => {
                              setMobileMenuOpen(false);
                              navigate("/login");
                            }}
                          >
                            Login
                          </button>
                        </div>
                      </div>
                    )}
                  </Navbar>
      {/* Background Images for Desktop */}
      <img src={Deco1} alt="" className="hidden md:block absolute left-0 top-[20%] w-1/3 max-w-xs z-0 pointer-events-none" />
      <img src={Deco5} alt="" className="hidden md:block absolute right-0 top-0 w-1/2 max-w-lg z-0 pointer-events-none" />
      <img src={Deco2} alt="" className="hidden md:block absolute left-10  lg:left-[10%] bottom-0 w-1/2 max-w-2xl z-0 pointer-events-none" />
      <img src={Deco4} alt="" className="hidden md:block absolute right-[10%] bottom-0 w-1/2 max-w-lg z-0 pointer-events-none" />
      <img src={Deco3} alt="" className="hidden md:block absolute left-1/2 bottom-0 w-1/2 max-w-2xl z-0 pointer-events-none" style={{transform: "translateX(-50%)"}} />
    {/* Logo */}
    <div className="absolute top-10 left-10 justify-start mb-6">
          {/* <img src={AECPLogo} alt="AECP Logo" className="h-16 md:h-20" /> */}
        </div>
      <div className="w-full max-w-2xl mx-auto px-4 py-8 md:py-16 z-10">
        
        {/* Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-2 text-black tracking-wide">REGISTER NOW!</h2>
        <p className="text-center text-gray-600 text-lg mb-6">Fill the information carefully</p>
        {/* Chamber Information */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-[#7c3a7a] mb-4">Chamber Information</h3>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <label className="block font-medium text-gray-700 mb-1">First Name <span className="text-#E08681">*</span></label>
                <input
                  type="text"
                  name="firstName"
                  value={form.firstName}
                  onChange={handleChange}
                  placeholder="Enter first name"
                  required
                  className="w-full rounded-xl  border-none shadow-md px-4 py-3 text-base focus:ring-2 focus:ring-#E08681 outline-none placeholder-gray-400"
                  style={{backgroundColor: "white"}}
                />
              </div>
              <div className="flex-1">
                <label className="block font-medium text-gray-700 mb-1">Last Name <span className="text-#E08681">*</span></label>
                <input
                  type="text"
                  name="lastName"
                  value={form.lastName}
                  onChange={handleChange}
                  placeholder="Enter last name"
                  required
                  className="w-full rounded-xl  border-none shadow-md px-4 py-3 text-base focus:ring-2 focus:ring-#E08681 outline-none placeholder-gray-400"
                  style={{backgroundColor: "white"}}
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <label className="block font-medium text-gray-700 mb-1">Mobile Number <span className="text-[#E08681]">*</span></label>
                <input
                  type="tel"
                  name="mobile"
                  value={form.mobile}
                  onChange={handleChange}
                  placeholder="Enter mobile number"
                  required
                  className="w-full rounded-xl  border-none shadow-md px-4 py-3 text-base focus:ring-2 focus:ring-[#E08681] outline-none placeholder-gray-400"
                  style={{backgroundColor: "white"}}
                />
              </div>
              <div className="flex-1">
                <label className="block font-medium text-gray-700 mb-1">Email Address <span className="text-[#E08681]">*</span></label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Enter email address"
                  required
                  className="w-full rounded-xl  border-none shadow-md px-4 py-3 text-base focus:ring-2 focus:ring-[#E08681] outline-none placeholder-gray-400"
                  style={{backgroundColor: "white"}}
                />
              </div>
            </div>
            <div>
              <label className="block font-medium text-gray-700 mb-1">Company Name <span className="text-[#E08681]">*</span></label>
              <input
                type="text"
                name="companyName"
                value={form.companyName}
                onChange={handleChange}
                placeholder="Enter company name"
                required
                className="w-full rounded-xl  border-none shadow-md px-4 py-3 text-base focus:ring-2 focus:ring-[#E08681] outline-none placeholder-gray-400"
                style={{backgroundColor: "white"}}
              />
            </div>
            <div>
              <label className="block font-medium text-gray-700 mb-1">Company Address <span className="text-[#E08681]">*</span></label>
              <input
                type="text"
                name="companyAddress"
                value={form.companyAddress}
                onChange={handleChange}
                placeholder="Enter company address"
                required
                className="w-full rounded-xl  border-none shadow-md px-4 py-3 text-base focus:ring-2 focus:ring-[#E08681] outline-none placeholder-gray-400"
                style={{backgroundColor: "white"}}
              />
            </div>
            <div>
              <label className="block font-medium text-gray-700 mb-1">GST Number <span className="text-[#E08681]">*</span></label>
              <input
                type="text"
                name="gstNumber"
                value={form.gstNumber}
                onChange={handleChange}
                placeholder="Enter company GST number"
                required
                className="w-full rounded-xl  border-none shadow-md px-4 py-3 text-base focus:ring-2 focus:ring-[#E08681] outline-none placeholder-gray-400"
              />
            </div>

            <div className="flex justify-center mt-4">
              <button
                type="submit"
                className="bg-[#E08681] text-black font-semibold text-lg rounded-lg px-12 py-3 shadow-md hover:bg-[#D77B6D] transition-all duration-200"
                style={{ minWidth: "180px" }}
                disabled={loading}
              >
                {loading ? (
                  <span>
                    <svg className="animate-spin h-5 w-5 mr-2 inline" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none"/>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                    </svg>
                    Registering...
                  </span>
                ) : (
                  "Register"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer /> 
      {/* Hide background images on mobile */}
      <style>{`
        @media (max-width: 767px) {
          img[alt=""].pointer-events-none { display: none !important; }
        }
      `}</style>
    </div>
  );
} 